






















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class TextInput extends Vue {
  @Prop()
  public value!: string;

  @Prop({ default: 'light' })
  public variant!: 'light' | 'dark' | 'outline';

  @Prop({ default: 'normal' })
  public sizing!: 'normal' | 'small';

  @Prop({ default: false })
  public hasError!: boolean;

  public mounted() {
    // this is necessary for IE11 because the @blur event does not include the relatedtarget correctly in IE11
    (this.$refs.input as HTMLInputElement).addEventListener('focusout', (event) => this.$emit('focusout', event));
  }

  public beforeDestroy(): void {
    (this.$refs.input as HTMLInputElement).removeEventListener('focusout', (event) => this.$emit('focusout', event));
  }

  public get otherListeners() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { input, ...listeners } = this.$listeners;
    return listeners;
  }

  public get hasPrefix(): boolean {
    return !!this.$slots.prefix;
  }

  public get hasSuffix(): boolean {
    return !!this.$slots.suffix;
  }

  public focus(): void {
    (this.$refs.input as HTMLInputElement)?.focus();
  }
}
